<template>
  <div id="about-you-form">
    <div>
      <h1>About You</h1>
    </div>
    <div class="section-summary">
        <p>Tell us a little about you to help us tailor your summary.</p>
    </div>
    <div class="form-section">
      <summary-col>
        <h3>Firm</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Company Name</label>
          <div class="input-wrapper wide">
          <input class="data-input" v-model="companyName"/>
          </div>
        </data-row>
      </data-col>
    </div>
    <div id="form-footer">
      <div class="button-wrapper back-button-wrapper">
        <BtnBack title="Back"/>
      </div>
      <div class="button-wrapper next-button-wrapper">
        <BtnNext title="Next" currentPage="about-you" />
      </div>
    </div>
  </div>
</template>


<script>
import BtnNext from './BtnNext.vue'
import BtnBack from './BtnBack.vue'
export default {
  //name: 'HelloWorld',
  props: {
  },
  computed: {
      companyName: {
        get () {
          return this.$store.state.company.name
        },
        set (value) {
          this.$store.commit('setCompanyName', value)
          //this.$store.commit('setLifeCover', Math.round(value * 0.5))
          //this.$store.commit('setBinsCover', value)
        }
      }
  },
  components: {
    BtnNext,
    BtnBack
  }
}
</script>